import { ADD_BANNER, DELETE_BANNER, GET_BANNER, UPDATE_BANNER } from "../types";

const initialState = {list: [], single: null, cities: []};

const reducer = (state = initialState, action) => {
    const {type, payload} = action;

    switch (type) {
        case GET_BANNER:
            return {...state, list: payload};

        case UPDATE_BANNER:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload._id ? payload : item
                ),
            };

        case ADD_BANNER:
            return {
                ...state,
                list: [payload, ...state.list],
            };

        case DELETE_BANNER:
            return {
                ...state,
                list: state.list.filter((item) => item.id !== payload.id),
            };

        default:
            return state;
    }
};

export default reducer;
